module.exports = __webpack_public_path__ + "static/media/swap.6cd2b1ed.svg";